export const APP_CURRENCY = {
  // Bolivianos
  code: 'BOB',
  locale: 'es-BO',
  symbol: 'Bs',
  fractionDigits: 2,
} as const;
